/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementAnimationIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ElementAnimationIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path
              d="M3.17411 7.48097C2.65779 6.44833 2.03701 6 1.5 6V5C2.61984 5 3.49906 5.89481 4.06853 7.03375C4.28576 7.4682 4.47018 7.95941 4.61619 8.49337L4.63857 8.44797C5.02708 7.67096 5.6563 7 6.5 7C7.3437 7 7.97292 7.67096 8.36143 8.44797C8.44423 8.61357 8.51995 8.79068 8.58799 8.97765C8.75995 8.68202 8.98473 8.40934 9.26172 8.22754C9.40032 8.5363 9.58961 8.81736 9.81899 9.06014C9.69506 9.13555 9.54063 9.29437 9.38655 9.60252C9.15666 10.0623 9.00003 10.7325 9 11.5C9 11.4999 9 11.5001 9 11.5L8 11.5002C8 11.5002 8 11.5003 8 11.5002C8 10.4565 7.7874 9.53598 7.467 8.89518C7.13165 8.22447 6.76087 8 6.5 8C6.23913 8 5.86835 8.22447 5.533 8.89518C5.2126 9.53598 5 10.4562 5 11.5H4C4 9.90394 3.67547 8.48369 3.17411 7.48097Z"
              fill="currentColor"
            />
            <path
              d="M14 7C14 8.10457 13.1046 9 12 9C10.8954 9 10 8.10457 10 7C10 5.89543 10.8954 5 12 5C13.1046 5 14 5.89543 14 7Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ElementAnimationIcon.tags = [
  'animation',
  'animate',
  'ix',
  'ix2',
  'ix3',
  'interaction',
  'interactions',
  'lottie',
];

ElementAnimationIcon.category = 'Navigator';

ElementAnimationIcon.iconSize = 16;
